export enum HardHatColumnFields {
  Snapshot = "mediaOutput",
  Location = "location",
  Camera = "cameraId",
  Confidence = "confidence",
  Timestamp = "timestamp",
}
